module.exports = __webpack_public_path__ + "img/mini-gold.14fc9453.webp";